export function ShouldSearchStart (helper) {
  // If the query is empty, it is not the search page, and there are no hierarchicalCategories set, stop the search from running
  if (helper.state.query === '' && window.theme.settings.template !== 'search') {
    return false
  } else {
    return true
  }
}

export function supapfolioV3Client () {
  const opts = {
    staticData: false
  }

  const applicationId = window.theme.settings.algoliaAppID

  const apiKey = window.theme.settings.algoliaSearchApiKey

  const catalogueKey = window.theme.settings.algoliaCatalog

  if (applicationId === null || apiKey === null || catalogueKey === null) {
    return null
  }

  return supafolio(`${applicationId}`, `${apiKey}`, `${catalogueKey}`, opts)
}

export function getTemplate (templateName) {
  return document.querySelector('.' + templateName + '-template').innerHTML
}

export function decodeHTML (html) {
  const txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}

export function shopifyCollectionDescription (helper) {
  // get category desc wrapper
  const categoryWrapper = document.getElementsByClassName('js-category-description-wrapper')[0]
  // get category description if necessary (ie.box is ticked (but not if 2 or more selected).)
  if (helper.state.disjunctiveFacetsRefinements.imprint && helper.state.disjunctiveFacetsRefinements.imprint.length < 2) {
    let imprint = helper.state.disjunctiveFacetsRefinements.imprint[0]
    // replace encoded space in imprint with dash to correctly get category description
    imprint = imprint.toLowerCase().replace(' ', '-')
    fetch('/collections/' + imprint + '.json').then(resp => resp.json()).then((data) => {
      if (data.collection) {
        const imprintData = data.collection
        let categoryTitle = ''
        let categoryDescription = ''
        if (imprintData.title) {
          categoryTitle = `<p class="category-description__title h3">${imprintData.title}</p>`
        }
        if (imprintData.description) {
          categoryDescription = imprintData.description
        }
        categoryWrapper.classList.remove('category-description__wrapper--no-description')
        categoryWrapper.innerHTML = categoryTitle + categoryDescription
      }
    })
  } else {
    // refresh with no content
    categoryWrapper.classList.add('category-description__wrapper--no-description')
    categoryWrapper.innerHTML = ''
  }
}
